import Controller, { OnClick, OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import { HttpService,  } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { ActionAPI, CheckboxAPI, FormAPI, InputAPI, ModalProps, ModalService, TextAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { FragmentNames, ScoreTiss_28ViewerAliases } from '../../../../codegen/index';
import InformationBarUtils from '../../../commons/header/information-bar-header-utils';
import { Endpoint } from '../../../../constants/endpoints';
import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../../constants/routes';

import { ScoreTISS28Request, ScoreTISS28Response } from '../../score-types';
import { BooleanUtils } from '../../../../utils/boolean-utils';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { Value } from '@philips-internal/oswald-ui-core';
import { ScoreAndIndexesService, ScoreListContext } from '../../scores-list/scores-list-service';
import { ScoreType } from '../../scores-references/score-reference-controller';
import { DateFormatterUtil } from '@philips-emr/health-professional-components/src/utils';
import { HealthProfessionalUser } from '../../../../app/authentication';

@Controller({ fragment: FragmentNames.SCORE_TISS_28_VIEWER })
export default class ScoreTiss28ViewerController extends BaseController {

  @Inject(ScoreTiss_28ViewerAliases.FORM_SCORE_TISS_28_VIEWER)
  private formAPI!: FormAPI;

  @Inject(ScoreTiss_28ViewerAliases.INPUT_EVATUALION_DATE)
  private inputDateAPI!: InputAPI;

  @Inject(ScoreTiss_28ViewerAliases.INPUT_HOUR)
  private inputHourAPI!: InputAPI;

  @Inject(ScoreTiss_28ViewerAliases.FIELD_PROFESSIONAL)
  private inputProfessionalApi!: InputAPI;

  @Inject(ScoreTiss_28ViewerAliases.TEXT_PUNCTUATION)
  private textPunctuationAPI!: TextAPI;

  @Inject(ScoreTiss_28ViewerAliases.TEXT_CLASSIFICATION)
  private textClassificationAPI!: TextAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_ACIDOSIS)
  private checkAcidosisAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_ACTIVE_DIURESIS)
  private checkActiveDiuresisAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_ARTIFICIAL_AIRWAY)
  private checkArtificialAirwayAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_CARDIO_RESSUSCITATION)
  private checkCardioRessuscitAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_CAT_ART_PERIPHERAL)
  private checkCatArtPeriAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_CENTRAL_VENOUS)
  private checkCentralVenousAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_DRAIN)
  private checkDrainAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_ENT_NUTRI)
  private checkEntNutriAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_FREQ_DRESSINGS)
  private checkFreqDressingAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_INTRACRANIAL_PRESSURE)
  private checkIntracranialAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_INTRAVENOUS_MED)
  private checkIntravenousMedAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_LAB)
  private checkLabAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_MECH_VENT)
  private checkMechVentAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_MONIT_ATRIUM)
  private checkMonitAtriumAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_MULTI_ICU)
  private checkMultiICUAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_MULTIVASO_MED)
  private checkMultivasoMedAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_OUT_ICU)
  private checkOutICUAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_PAREN_NUTRI)
  private checkParenNutriAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_REPO_VOL)
  private checkRepoVolAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_ROUTINE_DRESSINGS)
  private checkRoutineDressingAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_STANDARD_MONIT)
  private checkStandardMonitAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_SUP_VENT_SUPPORT)
  private checkSupVentSupportAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_TECH_HEMOFILTRATION)
  private checkTechHemoAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_TRAT_PULMONAR)
  private checkTratPulmonarAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_UNIQUE_ICU)
  private checkUniqueICUAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_UNIQUE_MEDICATION)
  private checkUniqueMedAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_URINE_DEBIT)
  private checkUrineDebitAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.CHECKBOX_VASO_MED)
  private checkVasoMedAPI!: CheckboxAPI;

  @Inject(ScoreTiss_28ViewerAliases.ACTION_INACTIVATE_SCORE_TISS_28)
  private actionInactivateAPI!: ActionAPI;

  @Inject(ScoreTiss_28ViewerAliases.ACTION_NEW_SCORE_TISS_28)
  private actionNewAPI!: ActionAPI;

  @Inject(ScoreTiss_28ViewerAliases.ACTION_REFERENCE_SCORE_TISS_28)
  private actionReferenceAPI!: ActionAPI;

  @OnMount({ target: ScoreTiss_28ViewerAliases.LAYOUT_SCORE_TISS_28_VIEWER })
  handleMountLayout(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.popNavigationItem();
    InformationBarUtils.collapsedBar = true;
    this.context.set({encounterId, patientId});
    ScoreListContext.currentTab = ScoreType.SCORE_TISS_28
  }

  @OnMount({ target: ScoreTiss_28ViewerAliases.FORM_SCORE_TISS_28_VIEWER })
  handleMountForm(): void {
    const { idScoreIndexes } = this.historyService.getCurrentRouteParams();
    this.formAPI.setLoading(true);
    this.fetchScoreTiss28(idScoreIndexes as string)
  }

  private showToast(message: string, level: ToastLevel): void {
    ToastService.open({
      dismissible: true,
      highlight: false,
      id: 'score-pews-create',
      level,
      message,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    })
  }

  private fetchScoreTiss28(sequenceNumber: string): Promise<void> {
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;

    return HttpService.get(Endpoint.SCORE_TISS_28, { sequenceNumber })
      .then(response => {
        const record = response.body as ScoreTISS28Response;
        const user = foundationContext.getUser() as HealthProfessionalUser;
        const scoreTiss28 = this.convertToValidType(record);
        const showInactivate = record.professionalCode === user.physicalPersonId && Boolean(record.showInactivate) && allowInfo;

        this.inputProfessionalApi.setValue(record.professionalName as string);
        this.formAPI.setData({...scoreTiss28});
        this.actionInactivateAPI.setEnabled(showInactivate);
        this.setFormValues(scoreTiss28)
      })
      .catch(err => this.showToast(err?.body.errorMessage, ToastLevel.ERROR))
      .finally(() => {
        this.formAPI.setLoading(false);
        this.actionNewAPI.setEnabled(allowInfo);
        this.actionReferenceAPI.setEnabled(allowInfo);
      })
  }

  private setFormValues(scoreTiss28: ScoreTISS28Request): void {
    this.checkAcidosisAPI.setValue(scoreTiss28.acidoseAlcalose);
    this.checkActiveDiuresisAPI.setValue(scoreTiss28.diureseAtiva);
    this.checkArtificialAirwayAPI.setValue(scoreTiss28.viasAerias);
    this.checkCardioRessuscitAPI.setValue(scoreTiss28.ressuscitCardio);
    this.checkCatArtPeriAPI.setValue(scoreTiss28.cateterArtPerif);
    this.checkCentralVenousAPI.setValue(scoreTiss28.viaVenosaCentral);
    this.checkDrainAPI.setValue(scoreTiss28.dreno);
    this.checkEntNutriAPI.setValue(scoreTiss28.nutEnteral);
    this.checkFreqDressingAPI.setValue(scoreTiss28.curativoFrequente);
    this.checkIntracranialAPI.setValue(scoreTiss28.pressaoIntracraniana);
    this.checkIntravenousMedAPI.setValue(scoreTiss28.medicEndovenosa);
    this.checkLabAPI.setValue(scoreTiss28.laboratorio);
    this.checkMechVentAPI.setValue(scoreTiss28.ventMecanica);
    this.checkMonitAtriumAPI.setValue(scoreTiss28.scMonitAtrioEsquerdo);
    this.checkMultiICUAPI.setValue(scoreTiss28.interMultiUti);
    this.checkMultivasoMedAPI.setValue(scoreTiss28.vasoativaMulti);
    this.checkOutICUAPI.setValue(scoreTiss28.interForaUti);
    this.checkParenNutriAPI.setValue(scoreTiss28.nutParent);
    this.checkRepoVolAPI.setValue(scoreTiss28.repVolemica);
    this.checkRoutineDressingAPI.setValue(scoreTiss28.curativoRotina);
    this.checkStandardMonitAPI.setValue(scoreTiss28.monitPadrao);
    this.checkSupVentSupportAPI.setValue(scoreTiss28.suepVentSupl);
    this.checkTechHemoAPI.setValue(scoreTiss28.tecHemofiltracao);
    this.checkTratPulmonarAPI.setValue(scoreTiss28.tratFuncaoPulmonar);
    this.checkUniqueICUAPI.setValue(scoreTiss28.interUnicaUti);
    this.checkUniqueMedAPI.setValue(scoreTiss28.medicaUnica);
    this.checkUrineDebitAPI.setValue(scoreTiss28.medDebitoUrina);
    this.checkVasoMedAPI.setValue(scoreTiss28.vasoativaUnica);
    this.inputHourAPI.setValue(scoreTiss28.time || '');
    this.inputDateAPI.setValue(scoreTiss28.evaluationDate);
    this.textClassificationAPI.setValue(scoreTiss28.result);
    this.textPunctuationAPI.setValue(scoreTiss28.punctuation);
  }

  private convertToValidType(scoreTiss28: ScoreTISS28Response): ScoreTISS28Request {
    return {
      acidoseAlcalose: BooleanUtils.isTrueValue(scoreTiss28.acidoseAlcalose),
      cateterArtPerif: BooleanUtils.isTrueValue(scoreTiss28.cateterArtPerif),
      curativoFrequente: BooleanUtils.isTrueValue(scoreTiss28.curativoFrequente),
      curativoRotina: BooleanUtils.isTrueValue(scoreTiss28.curativoRotina),
      diureseAtiva: BooleanUtils.isTrueValue(scoreTiss28.diureseAtiva),
      dreno: BooleanUtils.isTrueValue(scoreTiss28.dreno),
      evaluationDate: DateFormatterUtil.timeStamp(String(scoreTiss28.evaluationDate)),
      idScoreIndexes: scoreTiss28.idScoreIndexes,
      interForaUti: BooleanUtils.isTrueValue(scoreTiss28.interForaUti),
      interMultiUti: BooleanUtils.isTrueValue(scoreTiss28.interMultiUti),
      interUnicaUti: BooleanUtils.isTrueValue(scoreTiss28.interUnicaUti),
      laboratorio: BooleanUtils.isTrueValue(scoreTiss28.laboratorio),
      medDebitoUrina: BooleanUtils.isTrueValue(scoreTiss28.medDebitoUrina),
      medicaUnica: BooleanUtils.isTrueValue(scoreTiss28.medicaUnica),
      medicEndovenosa: BooleanUtils.isTrueValue(scoreTiss28.medicEndovenosa),
      monitPadrao: BooleanUtils.isTrueValue(scoreTiss28.monitPadrao),
      nutEnteral: BooleanUtils.isTrueValue(scoreTiss28.nutEnteral),
      nutParent: BooleanUtils.isTrueValue(scoreTiss28.nutParent),
      pressaoIntracraniana: BooleanUtils.isTrueValue(scoreTiss28.pressaoIntracraniana),
      professionalName: String(scoreTiss28.professionalName),
      punctuation: String(scoreTiss28.scoreQuantity) || '0',
      repVolemica: BooleanUtils.isTrueValue(scoreTiss28.repVolemica),
      ressuscitCardio: BooleanUtils.isTrueValue(scoreTiss28.ressuscitCardio),
      result: scoreTiss28.result as unknown as string || '',
      scMonitAtrioEsquerdo: BooleanUtils.isTrueValue(scoreTiss28.scMonitAtrioEsquerdo),
      suepVentSupl: BooleanUtils.isTrueValue(scoreTiss28.suepVentSupl),
      tecHemofiltracao: BooleanUtils.isTrueValue(scoreTiss28.tecHemofiltracao),
      time: scoreTiss28.time ? scoreTiss28.time.description : '',
      tratFuncaoPulmonar: BooleanUtils.isTrueValue(scoreTiss28.tratFuncaoPulmonar),
      vasoativaMulti: BooleanUtils.isTrueValue(scoreTiss28.vasoativaMulti),
      vasoativaUnica: BooleanUtils.isTrueValue(scoreTiss28.vasoativaUnica),
      ventMecanica: BooleanUtils.isTrueValue(scoreTiss28.ventMecanica),
      viasAerias: BooleanUtils.isTrueValue(scoreTiss28.viasAerias),
      viaVenosaCentral: BooleanUtils.isTrueValue(scoreTiss28.viaVenosaCentral),
    }
  }

  private getReference(): void {
    const scoreType = 'tiss-28';
    const modalProperties: ModalProps = {
      closeable: true,
      closeByDocument: false,
      closeByEscape: false,
      focusOnOpen: false,
      fragment: 'score-reference',
      id: 'score-reference',
      onCancel: () => { },
      onSubmit: () => { },
      title: 'tws.reference-pain-scale-value',
      uuid: generateUUID(),
    };

    modalProperties.contextData = {
      scoreType,
    }

    ModalService.openFullscreen(modalProperties);
  }

  @OnClick({ target: ScoreTiss_28ViewerAliases.ACTION_NEW_SCORE_TISS_28 })
  handleClickNew(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(ApplicationRoute.SCORE_TISS_28_CREATE, {
      encounterId,
      patientId,
    });
  }

  @OnClick({ target: ScoreTiss_28ViewerAliases.ACTION_INACTIVATE_SCORE_TISS_28 })
  handleClickInactivate(): void {
    const { idScoreIndexes } = this.historyService.getCurrentRouteParams() as Record<string, Value>;
    const modalProperties: ModalProps = {
      closeable: false,
      closeByDocument: false,
      closeByEscape: false,
      focusOnOpen: false,
      fragment: 'score-inactivate',
      id: 'score-inactivate',
      onCancel: () => { },
      onSubmit: () => { },
      title: 'title.disable-record',
      uuid: generateUUID(),
    };

    modalProperties.contextData = {
      idScoreIndexes,
    }

    ModalService.openDefault(modalProperties);
  }

  @OnClick({ target: ScoreTiss_28ViewerAliases.ACTION_REFERENCE_SCORE_TISS_28 })
  handleClickReference(): void {
    this.getReference();
  }

  @OnUnmount(ScoreTiss_28ViewerAliases.LAYOUT_SCORE_TISS_28_VIEWER)
  handleUnmount(): void {
    ScoreListContext.clean();
    ScoreListContext.currentTab = ScoreType.SCORE_TISS_28;
  }

}
